import { Divider, Typography,useTheme } from "@mui/material";
import PropTypes from 'prop-types';


const PageHeader = ({ title, width }) => {
    const theme = useTheme();
    return (
        <div style={{
            display: "flex",
            alignItems: 'center',
            marginBottom: 20

        }}>
            <div style={{ backgroundColor: theme.palette.secondary.main, width: 11, height: 24, marginRight: 29 }} />
            <Typography variant="p" component="p" fontWeight='bolder' >
                {title}
            </Typography>

            <Divider sx={{
                width: width || '82%',
                height: 10,
                marginLeft: '5px',
            }}

            />

        </div>
    );
}
PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    width: PropTypes.string,
};
export default PageHeader